import { render, staticRenderFns } from "./SocialConfirmBox.vue?vue&type=template&id=57241bb4&"
import script from "./SocialConfirmBox.vue?vue&type=script&lang=ts&"
export * from "./SocialConfirmBox.vue?vue&type=script&lang=ts&"
import style0 from "./SocialConfirmBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports